/**
 * bewaesserung_resetAbschnittData
 * @param abschnitt
 * @returns {*}
 */
window.bewaesserung_resetAbschnittData = function(abschnitt) {
  abschnitt.find('.section-detail-mittel').remove();
};

/**
 * bewaesserung_calculateWassermengeProStundeOberkrone
 * @param durchmesserDuese
 * @param druckDuese
 * @returns {*}
 */
window.bewaesserung_calculateWassermengeProStundeOberkrone = function(durchmesserDuese, druckDuese) {
  if (typeof wassermengeList[durchmesserDuese] !== 'undefined' && typeof wassermengeList[durchmesserDuese][druckDuese] !== 'undefined') {
    return wassermengeList[durchmesserDuese][druckDuese];
  }
  return 0;
};

/**
 * bewaesserung_berechneWassermenge
 * @param abschnitt
 * @param dauer
 * @param bewaesserungstyp
 * @returns {{mm: number, liter: number}|number}
 */
window.bewaesserung_berechneWassermenge = function(abschnitt, dauer, bewaesserungstyp) {
  const bewaesserungsanlage = abschnitt.bewaesserungsanlage;

  if (bewaesserungstyp === 'Oberkrone') {
    if (!abschnitt.oberkrone) {
      return 0.0;
    }

    const beregnerGesamt = bewaesserungsanlage.oberkrone_anzahl;
    const druckDuese = numberFormat(bewaesserungsanlage.oberkrone_druck_duese, 1);
    const durchmesserDuese = numberFormat(bewaesserungsanlage.oberkrone_durchmesser_duese, 1);
    const flaecheGesamt = bewaesserungsanlage.flaeche;
    const flaecheAbschnitt = abschnitt.flaeche;

    const wassermengeProDuese = bewaesserung_calculateWassermengeProStundeOberkrone(durchmesserDuese, druckDuese);
    const wassermengeInLiter = flaecheAbschnitt / flaecheGesamt * beregnerGesamt * wassermengeProDuese * dauer;

    const mm = wassermengeInLiter / flaecheAbschnitt;

    return {
      mm: mm,
      liter: roundWassermengeMillimeter(mm) * abschnitt.flaeche,
    };

  } else if (bewaesserungstyp === 'Tropfer') {
    if (!abschnitt.tropfer) {
      return 0.0;
    }

    const pflanzabstand = abschnitt.pflanzabstand;
    const anzahlPflanzen = abschnitt.anzahlPflanzen;
    const abstandTropfer = bewaesserungsanlage.tropfer_abstand_tropfer;
    const wassermengeProTropfer = bewaesserungsanlage.tropfer_wassermenge_pro_tropfer;

    const mm = pflanzabstand * anzahlPflanzen / abstandTropfer * wassermengeProTropfer * dauer / abschnitt.flaeche;
    return {
      mm: mm,
      liter: roundWassermengeMillimeter(mm) * abschnitt.flaeche,
    };

  } else {
    return 0;
  }
};

/**
 * bewaesserung_recalculateSumme
 * @param summeAlt
 * @param dauer
 * @param alleAbschnitteId
 * @param abschnitte
 * @returns {*&{mittel: {}}}
 */
window.bewaesserung_recalculateSumme = function(summeAlt, dauer, alleAbschnitteId, abschnitte) {
  const flaecheGesamt = summiereFlaeche(alleAbschnitteId.map(id => abschnitte[id]));

  const literGesamtBerechnet = alleAbschnitteId.map(id => abschnitte[id]).map(a => bewaesserung_berechneWassermenge(a, dauer, summeAlt.typ)).map(m => m.liter).reduce((summe, l) => summe + l, 0);

  return {
    ...summeAlt,
    dauer: dauer,
    wassermengeBerechnetMillimeter: roundWassermengeMillimeter(literGesamtBerechnet / flaecheGesamt),
  };
};